// extracted by mini-css-extract-plugin
export var accordionItem = "index-module--accordionItem--sIZEn";
export var accordionHeader = "index-module--accordionHeader--10ag1";
export var accordionHeaderActive = "index-module--accordionHeaderActive--2opuh";
export var accordionBody = "index-module--accordionBody--3b1Bs";
export var collapseIcon = "index-module--collapseIcon--3PCFb";